import { css } from '@emotion/react';
import styled from '@emotion/styled';

const StyledSvg = styled('svg')(
    () => css`
        animation: spinner 1s linear infinite;

        @media (prefers-reduced-motion) {
            & {
                animation: none;
            }
        }

        @keyframes spinner {
            to {
                transform: rotate(360deg);
            }
        }
    `
);

export { StyledSvg };
